"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Insurance = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const InsuranceTable_1 = require("./InsuranceTable");
const Insurance = ({ labels: { tableHeaderLabel = 'Insurance Accepted', nextPageLabel = 'Next', previousPageLabel = 'Previous', noRecordsLabel = 'This provider does not have any accepted insurance records on file.', noRecordsOnSearchLabel = 'No insurance records could be found that match your search criteria. Please remove your search term and try again.' } = {}, provider, stateEventHandlers }) => {
    const { insurance_accepted = [] } = provider;
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "insurance" },
        react_1.default.createElement(InsuranceTable_1.InsuranceTable, { id: `${provider.id}-insurance`, labels: {
                tableHeaderLabel,
                nextPageLabel,
                previousPageLabel,
                noRecordsLabel,
                noRecordsOnSearchLabel
            }, insuranceAccepted: insurance_accepted, stateEventHandlers: stateEventHandlers })));
};
exports.Insurance = Insurance;
//# sourceMappingURL=Insurance.js.map